import * as React from 'react';

import {ImportStatusBanner} from 'shells/dromo/import-status-banner';
import {QuotaImportIcon} from 'shells/icon/svg/quota-import-icon';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import {ImportIdentifier} from 'nutshell-graphql-types';
import type {ImportStatus as ImportStatusType} from 'nutshell-graphql-types';

import {useGetDromoImports} from '../graphql/hooks/use-get-dromo-imports';
import {DromoImportsTable} from '../shared/dromo-imports-table';

import {DromoQuotaImportButton} from './quota-dromo-import-button';

export function DromoQuotaImporter() {
    const [importStatus, setImportStatus] = React.useState<ImportStatusType>('IN_PROGRESS');
    const [showImportStatusBanner, setShowImportStatusBanner] = React.useState<boolean>(false);

    const {dromoImports, isLoading, errorMessage, refetch} = useGetDromoImports(
        ImportIdentifier.QUOTA
    );

    React.useEffect(() => {
        if (dromoImports?.currentImport) {
            setImportStatus('IN_PROGRESS');
        } else if (
            dromoImports &&
            dromoImports.currentImport === null &&
            dromoImports.recentCompletedImport
        ) {
            setImportStatus('COMPLETED');
        }

        if (dromoImports?.recentCompletedImport) {
            setShowImportStatusBanner(true);
        }
    }, [dromoImports]);

    return (
        <Stack spacing={32}>
            {showImportStatusBanner && (
                <ImportStatusBanner
                    onRefresh={() => {
                        refetch();
                    }}
                    onViewEntity={() => {
                        window.location.pathname = 'sales/sales-quotas';
                    }}
                    status={importStatus}
                    type='quotas'
                />
            )}
            <Stack spacing={16} isHorizontal={true}>
                <QuotaImportIcon size={86} />
                <Stack spacing={8}>
                    <Body size='large' isBold={true} color='dark'>
                        Import quotas from a CSV
                    </Body>
                    <DromoQuotaImportButton
                        variant='primary'
                        onUploaded={() => {
                            setImportStatus('IN_PROGRESS');
                            setShowImportStatusBanner(true);
                            setTimeout(() => {
                                refetch();
                            }, 2000);
                        }}
                    />
                    <Body size='small' color='light'>
                        Supports .csv, .tsv, .txt, etc.
                    </Body>
                </Stack>
            </Stack>
            <DromoImportsTable
                importHistory={(dromoImports && dromoImports.imports) || []}
                isLoading={isLoading}
                errorMessage={errorMessage}
                importType='quotas'
            />
        </Stack>
    );
}
